module.exports = __webpack_public_path__ + "static/img/6.e59d6b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/6.png
// module id = v/7e
// module chunks = 0